import React, { useState } from 'react';
import { IPHStoreContainer } from '@atlassian/eoc-iph-store';
import OnCall, { ScheduleTours, Loading } from '@atlassian/eoc-on-call';
import { SpotlightTrigger } from '@atlassian/eoc-spotlight-store';
import CoordinationClient from '@atlassian/jira-engagement/src/ui/coordination-client/index.tsx';
import { GlobalContextContainer } from '@atlassian/jira-eoc-global-context/src/index.tsx';
import { ConsolidatedStateWrapper } from '@atlassian/jira-eoc-tenant-info/src/ui/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/DocumentTitle.tsx';
import { useHelpPanelLink } from '@atlassian/jira-help-panel-button/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { onCallLinks } from './constants.tsx';
import { messages } from './messages.tsx';
import EditRotationTour from './ui/tours/edit-rotation/index.tsx';
import OnCallTour from './ui/tours/get-started/index.tsx';
import { ListRotationTour } from './ui/tours/list-rotation/index.tsx';
import { RoutingRuleTour } from './ui/tours/routing-rule/index.tsx';
import { ScheduleActionsTour } from './ui/tours/schedule-actions/index.tsx';
import { ShiftTileTour } from './ui/tours/shift-tile/index.tsx';

const OnCallPage = () => {
	const helpPanelLink = useHelpPanelLink();
	const { formatMessage } = useIntl();

	const [renderGetStartedTour, setRenderGetStartedTour] = useState(false);
	const [renderRoutingRuleTour, setRenderRoutingRuleTour] = useState(false);

	return (
		<JSErrorBoundary id="eoc.on-call" packageName="jiraEocOnCall" teamName="tardis">
			<GlobalContextContainer teamName="tardis" packageName="jiraEocOnCall">
				<AuthenticationCheck>
					<DocumentTitle title={formatMessage(messages.title)} />
					<ConsolidatedStateWrapper loadingComponent={<Loading />}>
						<IPHStoreContainer clickHandler={helpPanelLink} links={onCallLinks}>
							<OnCall
								onReady={() => setRenderGetStartedTour(true)}
								onRoutingRuleModalOpen={() => setRenderRoutingRuleTour(true)}
							/>

							<SpaStatePageReady />

							{renderGetStartedTour && (
								<CoordinationClient
									messageId="jira-ops_on_call_onboarding"
									messageType="engagement"
								>
									<OnCallTour />
								</CoordinationClient>
							)}

							{renderRoutingRuleTour && (
								<CoordinationClient
									messageId="jira-ops_on_call_routing_rules"
									messageType="engagement"
								>
									<RoutingRuleTour />
								</CoordinationClient>
							)}

							<SpotlightTrigger id={ScheduleTours.rotationList}>
								<CoordinationClient
									messageId="jira-ops_on_call_schedule_list_rotation"
									messageType="engagement"
								>
									<ListRotationTour />
								</CoordinationClient>
							</SpotlightTrigger>

							<SpotlightTrigger id={ScheduleTours.rotationEdit}>
								<CoordinationClient
									messageId="jira-ops_on_call_schedule_rotation_edit"
									messageType="engagement"
								>
									<EditRotationTour />
								</CoordinationClient>
							</SpotlightTrigger>

							<SpotlightTrigger id={ScheduleTours.shiftTile}>
								<CoordinationClient
									messageId="jira-ops_on_call_schedule_tile_shift"
									messageType="engagement"
								>
									<ShiftTileTour />
								</CoordinationClient>
							</SpotlightTrigger>

							<SpotlightTrigger id={ScheduleTours.scheduleActions}>
								<CoordinationClient
									messageId="jira-ops_on_call_schedule_actions"
									messageType="engagement"
								>
									<ScheduleActionsTour />
								</CoordinationClient>
							</SpotlightTrigger>
						</IPHStoreContainer>
					</ConsolidatedStateWrapper>
				</AuthenticationCheck>
			</GlobalContextContainer>
		</JSErrorBoundary>
	);
};

export default OnCallPage;
